import { useMemo } from 'react';
import { GENERATE_STATE } from '../../constants/FJEnumConstant';
import type { FJGeneratingTaskItem } from '../../redux/slice/FJGeneratingPageSlice';

const GENERATING_TASK_DEFS: Pick<FJGeneratingTaskItem, 'id' | 'labelKey'>[] = [
    { id: 'video-uploading', labelKey: 'upload-video' },
    { id: 'audio-transcribing', labelKey: 'transcribe-voice' },
    { id: 'extract-highlights', labelKey: 'extract-highlights' },
    { id: 'video-integration', labelKey: 'merge-scenes' },
];

/**
 * 按总进度 0–100 将各阶段均分，推导每步的 completed / loading / pending。
 * 每步占 100/n；例如 4 步时每步 25%。
 */
function applyEqualProgressToTasks(overallProgress: number): FJGeneratingTaskItem[] {
    const tasks = GENERATING_TASK_DEFS.map(
        (d): FJGeneratingTaskItem => ({ ...d, status: GENERATE_STATE.PENDING }),
    );
    const n = tasks.length;
    if (n === 0) return tasks;
    const p = Math.max(0, Math.min(100, Math.round(overallProgress)));
    const segment = 100 / n;

    if (p >= 100) {
        return tasks.map((t): FJGeneratingTaskItem => ({ ...t, status: GENERATE_STATE.SUCCEEDED }));
    }

    const completedCount = Math.min(Math.floor(p / segment), n - 1);

    return tasks.map((t, i): FJGeneratingTaskItem => {
        if (i < completedCount) {
            return { ...t, status: GENERATE_STATE.SUCCEEDED };
        }
        if (i === completedCount) {
            return { ...t, status: 'loading' };
        }
        return { ...t, status: GENERATE_STATE.PENDING };
    });
}

export function useGeneratingTasks(overallProgress: number): FJGeneratingTaskItem[] {
    return useMemo(() => applyEqualProgressToTasks(overallProgress), [overallProgress]);
}
